export default __webpack_public_path__ + "static/media/4.42e821d7.png";